import { FaAngleDoubleLeft, FaBars } from 'react-icons/fa';
import styled, { css } from 'styled-components';

interface ListItemProps {
  isSelected: boolean;
  disabled?: boolean | false;
}

interface ContainerProps {
  show: boolean;
  isMobile: boolean;
}

interface IconProps {
  show: 'true' | 'false';
  $isMobile?: boolean;
}

export const Container = styled.div<ContainerProps>`
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  z-index: 2;
  padding-left: 30px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  position: ${({ isMobile }) => (!isMobile ? 'sticky' : 'relative')};
  top: 0;

  .Collapsible {
    padding-left: 6px;
  }

  @media (max-width: 769px) {
    position: absolute;
    border-radius: 10px;
    padding: ${({ show }) => (show ? '10px 15px 10px 15px' : '0px')};
    top: 10px;
    right: 50px;
    min-height: 35px;
    max-height: 300px;
    box-shadow: ${({ show }) =>
    !show ? 'none' : '0px 4px 5px rgba(0, 0, 0, 0.2)'};
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const List = styled.ul`
  list-style-type: none;

  @media (max-width: 769px) {
    overflow: auto;
    overflow-x: hidden;
  }
`;

export const ListItem = styled.li<ListItemProps>`
  font-size: 15px;
  margin-bottom: 8px;
  padding-left: 6px;
  font-weight: 400;
  transition: transform 200ms;
  color: ${(props) =>
    props.isSelected
      ? props.theme.colors.primary
      : props.theme.colors.darkText};
  text-decoration: ${(props) =>
    props.isSelected ? `underline ${props.theme.colors.primary} ` : 'none'};
  text-underline-offset: 2px;
  ${(props) => {
    if (props.disabled) return `pointer-events: none; opacity: 0.3;`;
    return '';
  }}

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`;

export const ChildrenItem = styled.li<ListItemProps>`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2px;
  transition: transform 200ms;

  color: ${(props) =>
    props.isSelected
      ? props.theme.colors.primary
      : props.theme.colors.darkText};

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`;

export const ChildrenContainer = styled.div`
  padding-left: 10px;
  margin: 0 0 8px 0;
`;

export const CollapseButton = styled.button`
  display: flex;
  width: 25px;
  height: 25px;
  border-radius: 25px;
  background-color: #fff;
  position: absolute;
  right: -13px;
  top: 33px;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  @media (max-width: 769px) {
    right: -30px;
    top: 6px;
  }
`;

export const CollapseIcon = styled(FaAngleDoubleLeft) <IconProps>`
  color: ${(props) => props.theme.colors.darkText};
  transition: 0.5s;
  ${({ show, $isMobile }) =>
    show === 'true'
      ? css`
          transform: ${$isMobile ? 'rotate(180deg)' : 'rotate(0deg)'};
        `
      : css`
          transform: ${$isMobile ? 'rotate(0deg)' : 'rotate(180deg)'};
        `}
`;

export const SupergroupContainer = styled.div`
  display: flex;
  width: 25px;
  height: 25px;
  border-radius: 25px;
  background-color: #fff;
  position: absolute;
  right: 70px;
  top: 6px;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);

  cursor: pointer;
  @media (max-width: 769px) {
    right: 70px;
    top: 6px;
  }
`;

export const SupergroupIcon = styled(FaBars)`
  color: ${(props) => props.theme.colors.darkText};
  font-size: 18px;
`;
